// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__qJy02","modalFooterButton":"ModalNotes_modalFooterButton__3BgTq"};